
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view/[contentId]",
      function () {
        return require("private-next-pages/view/[contentId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view/[contentId]"])
      });
    }
  